import { render, staticRenderFns } from "./BodegaForm.vue?vue&type=template&id=6c720104"
import script from "./BodegaForm.vue?vue&type=script&lang=js"
export * from "./BodegaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports